import {
  DeleteOutlineIcon,
  MoreMenuIconButton,
  type MoreMenuIconButtonOption,
  type MoreMenuIconButtonProps,
} from '@shared/components';

import { useQConfigStructureModal } from '../../providers';

interface SubjectTableRowMenuProps extends Omit<MoreMenuIconButtonProps, 'options'> {
  subjectId: string;
}

export function SubjectTableRowMenu(props: Readonly<SubjectTableRowMenuProps>) {
  const { subjectId } = props;
  const { setAction } = useQConfigStructureModal();
  const handleRemove = () => {
    setAction({
      action: 'QCONFIG_DELETE',
      payload: { qConfigStructureId: subjectId },
    });
  };

  const subjectMenuOptions: MoreMenuIconButtonOption[] = [
    {
      icon: (
        <DeleteOutlineIcon
          sx={(theme) => ({
            color: theme.palette.error.main,
          })}
        />
      ),
      label: 'Remove',
      onClick: handleRemove,
      sx: (theme) => ({
        ':hover': {
          backgroundColor: theme.palette.primary.lighter,
        },
        color: theme.palette.error.main,
      }),
    },
  ];
  return (
    <MoreMenuIconButton
      options={subjectMenuOptions}
      slotProps={{
        iconButton: { sx: { color: (theme) => theme.palette.grey[500] } },
      }}
    />
  );
}
